(function ($, XTT) {
	'use strict';

	XTT.mobiletabs = {
		_autoload: [
			'bindMobileTabsEvents'
		],

		bindMobileTabsEvents: function () {
			XTT.mobiletabs.$navTrigger = $('.nav-tabs__trigger');
			XTT.mobiletabs.$nav = $('.nav-tabs');
			XTT.mobiletabs.$navItem = XTT.mobiletabs.$nav.find('.nav-item a');

			XTT.mobiletabs.$navItem.on('click', XTT.mobiletabs.changeCurrent);
			XTT.mobiletabs.$navTrigger.on('click', XTT.mobiletabs.openItems);
		}, 

		changeCurrent: function (e) {
			XTT.mobiletabs.$nav.prev('.nav-tabs__trigger').text($(this).text());
			XTT.mobiletabs.closeItems();
			e.preventDefault();
		},

		openItems: function(e) {
			XTT.mobiletabs.$nav.toggleClass('open');
			e.preventDefault();
		},

		closeItems: function() {
			XTT.mobiletabs.$nav.removeClass('open');
		}

	};

})
(jQuery, XTT);